import { render, staticRenderFns } from "./dashboardTable.vue?vue&type=template&id=59056238"
import script from "./dashboardTable.vue?vue&type=script&lang=js"
export * from "./dashboardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports